import { render, staticRenderFns } from "./ConfirmationDialogReorderHubItems.vue?vue&type=template&id=66c781d3"
import script from "./ConfirmationDialogReorderHubItems.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogReorderHubItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports